import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=5f64ebb8&scoped=true&"
import script from "./CustomerOrders.vue?vue&type=script&lang=js&"
export * from "./CustomerOrders.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerOrders.vue?vue&type=style&index=1&id=5f64ebb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64ebb8",
  null
  
)

export default component.exports